import { render } from "./StakeInput.vue?vue&type=template&id=834143b6&scoped=true"
import script from "./StakeInput.vue?vue&type=script&lang=js"
export * from "./StakeInput.vue?vue&type=script&lang=js"

import "./StakeInput.vue?vue&type=style&index=0&id=834143b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-834143b6"

export default script